import { useTheme } from '../context/ThemeContext';

export default function ColorModeToggle({ compact = false }) {
  const { colorMode, setColorMode, resolvedMode } = useTheme();

  if (compact) {
    const next = resolvedMode === 'dark' ? 'light' : 'dark';
    return (
      <button
        type="button"
        className="color-mode-toggle"
        onClick={() => setColorMode(next)}
        title={resolvedMode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        aria-label={resolvedMode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {resolvedMode === 'dark' ? '☀ Light' : '☾ Dark'}
      </button>
    );
  }

  return (
    <div className="color-mode-group" role="group" aria-label="Color mode">
      {[
        { id: 'light', label: 'Light' },
        { id: 'dark', label: 'Dark' },
        { id: 'system', label: 'System' },
      ].map(({ id, label }) => (
        <button
          key={id}
          type="button"
          className={`color-mode-option${colorMode === id ? ' active' : ''}`}
          onClick={() => setColorMode(id)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
